import CheckProviderDetail from "./CheckProviderDetail";
import RegisterNewDataProvider from "./RegisterNewDataProvider";
import PermissionsDetail from "./PermissionsDetail";
const checkProviderDetail={
     CheckProviderDetail,
     RegisterNewDataProvider,
     PermissionsDetail
}
export default checkProviderDetail